import React, { useEffect, useMemo, useState } from "react";
import { Grid, Card, Badge, Button } from "tabler-react";
import Select from "react-select";
import { NotificationManager } from "react-notifications";
import SiteWrapper from "../../../../SiteWrapper.react";
import { Crud_Catalogos } from "../../../../herramientas/Crud_Catalogos";
import TablePageable from "../../../../Helpers/TablePageable.react";

const OPCION_DEFAULT = { value: 0, label: "Selecciona una opción" };

const AdminExtensionesPage = () => {
  const [plataformas, setPlataformas] = useState([OPCION_DEFAULT]);
  const [plataformaSeleccionada, setPlataformaSeleccionada] = useState(OPCION_DEFAULT);
  const [usuarios, setUsuarios] = useState([]);
  // Todas las extensiones del sistema (softphone_v3/all)
  const [extensiones, setExtensiones] = useState([]);
  // Configuración de la plataforma seleccionada (softphone_configuracion/{id})
  const [plataformaConfig, setPlataformaConfig] = useState(null);
  // Información de área y team obtenida de Lambicom (area_id / team_id)
  const [areaInfo, setAreaInfo] = useState(null);
  const [teamInfo, setTeamInfo] = useState(null);
  // Control del modal de detalles de la plataforma
  const [showDetalle, setShowDetalle] = useState(false);
  // Control del modal de configuración (crear/actualizar)
  const [showConfig, setShowConfig] = useState(false);
  // Formulario de configuración de plataforma. El campo id === id_plataforma.
  const [configForm, setConfigForm] = useState({});
  // Indica si el formulario edita un registro existente o crea uno nuevo
  const [configEsNuevo, setConfigEsNuevo] = useState(false);
  const [guardandoConfig, setGuardandoConfig] = useState(false);
  // Opciones para los react-select de área y team en el modal de configuración
  const [areaOpciones, setAreaOpciones] = useState([]);
  const [teamOpciones, setTeamOpciones] = useState([]);
  // Objeto {value, label} seleccionado en cada select (para mostrar el name)
  const [teamSeleccionado, setTeamSeleccionado] = useState(null);
  const [areaSeleccionada, setAreaSeleccionada] = useState(null);
  const [loading, setLoading] = useState(false);
  // id de usuario para el que se está creando el usuario/agente (evita doble click)
  const [creandoId, setCreandoId] = useState(null);

  // ----- Asignación / desasignación de extensiones -----
  // Control del modal de asignación de extensión
  const [showAsignar, setShowAsignar] = useState(false);
  // Usuario al que se le asignará la extensión
  const [usuarioAsignar, setUsuarioAsignar] = useState(null);
  // Opciones {value, label, data} de extensiones disponibles (no asignadas)
  const [extensionesDisponibles, setExtensionesDisponibles] = useState([]);
  // Extensión seleccionada en el react-select del modal
  const [extensionSeleccionada, setExtensionSeleccionada] = useState(null);
  // Cargando el catálogo de extensiones disponibles
  const [cargandoDisponibles, setCargandoDisponibles] = useState(false);
  // Enviando la asignación (evita doble click)
  const [asignando, setAsignando] = useState(false);
  // id de usuario que se está desasignando (evita doble click)
  const [desasignandoId, setDesasignandoId] = useState(null);

  useEffect(() => {
    cargarPlataformas();
    cargarExtensiones();
  }, []);

  useEffect(() => {
    if (plataformaSeleccionada.value) {
      cargarUsuarios(plataformaSeleccionada.value);
      cargarPlataformaConfig(plataformaSeleccionada.value);
    } else {
      setUsuarios([]);
      setPlataformaConfig(null);
      setAreaInfo(null);
      setTeamInfo(null);
    }
  }, [plataformaSeleccionada]);

  const cargarPlataformas = () => {
    Crud_Catalogos("plataformas/usuario/6", "", "get", "", [])
      .then((res) => {
        let plataformasTem = [OPCION_DEFAULT];
        for (let p of res) {
          plataformasTem.push({ value: p.id, label: p.nombre, data: p });
        }
        setPlataformas(plataformasTem);
      })
      .catch(() => NotificationManager.error("Error al cargar plataformas"));
  };

  const cargarExtensiones = () => {
    Crud_Catalogos("softphone_v3/all", "softphone", "get", "", [])
      .then((res) => {
        setExtensiones(res || []);
      })
      .catch(() => NotificationManager.error("Error al cargar extensiones"));
  };

  const cargarPlataformaConfig = (plataformaId) => {
    setPlataformaConfig(null);
    setAreaInfo(null);
    setTeamInfo(null);
    Crud_Catalogos("softphone_configuracion/" + plataformaId, "", "get", "", [])
      .then((res) => {
        setPlataformaConfig(res || null);
        // Con la config obtenida, cargar el área y el team desde Lambicom
        if (res && res.areaId) {
          cargarArea(res.areaId);
        }
        if (res && res.teamId) {
          cargarTeam(res.teamId);
        }
      })
      .catch(() =>
        NotificationManager.error("Error al cargar configuración de la plataforma")
      );
  };

  // Obtiene la información del área (Lambicom) por su UUID
  const cargarArea = (areaId) => {
    Crud_Catalogos(
      "softphone_v3/area?provedor=4&areaId=" + areaId,
      "softphone",
      "get",
      "",
      []
    )
      .then((res) => {
        // La API puede devolver el objeto directo o envuelto en { area: {...} }
        setAreaInfo(res && res.area ? res.area : res || null);
      })
      .catch(() => NotificationManager.error("Error al cargar el área"));
  };

  // Obtiene la información del team (Lambicom) por su UUID
  const cargarTeam = (teamId) => {
    Crud_Catalogos(
      "softphone_v3/team?provedor=4&teamId=" + teamId,
      "softphone",
      "get",
      "",
      []
    )
      .then((res) => {
        setTeamInfo(res && res.team ? res.team : res || null);
      })
      .catch(() => NotificationManager.error("Error al cargar el team"));
  };

  const cargarUsuarios = (plataformaId) => {
    setLoading(true);
    Crud_Catalogos("usuarios/plataforma/" + plataformaId, "", "get", "", [])
      .then((res) => {
        // Solo usuarios activos (estatus === 1)
        const activos = (res || []).filter((u) => u.estatus === 1);
        setUsuarios(activos);
        setLoading(false);
      })
      .catch(() => {
        NotificationManager.error("Error al cargar usuarios");
        setLoading(false);
      });
  };

  // Nombre de plataforma (para el detalle)
  // Nombre de plataforma (para el detalle).
  // Si la plataforma no está en el listado del usuario, se indica y se muestra el id.
  const nombrePlataforma = (idPlataforma) => {
    const p = plataformas.find((pl) => pl.value === idPlataforma);
    if (p && p.value) {
      return p.label;
    }
    return `No tienes asignada esta plataforma (ID: ${idPlataforma})`;
  };

  // Mapa id_usuario -> extensiones asignadas (en cualquier plataforma)
  const extensionesPorUsuario = useMemo(() => {
    const mapa = {};
    for (const ext of extensiones) {
      if (!ext || ext.id == null) continue;
      if (!mapa[ext.id]) mapa[ext.id] = [];
      mapa[ext.id].push(ext);
    }
    return mapa;
  }, [extensiones]);

  // Extensiones del usuario (en cualquier plataforma)
  const extensionesUsuario = (usuarioId) => extensionesPorUsuario[usuarioId] || [];

  // ¿El usuario ya tiene creado su usuario/agente webphone (en la plataforma)?
  const tieneExtension = (usuarioId) => extensionesUsuario(usuarioId).length > 0;

  // Crea el usuario/agente webphone para un usuario en la plataforma seleccionada.
  // El backend arma nombre, apellido y teléfono desde la persona; solo enviamos email y password.
  const crearUsuarioWebphone = (usuario) => {
    if (!plataformaSeleccionada.value) {
      NotificationManager.warning("Selecciona una plataforma primero");
      return;
    }
    const email = usuario.persona ? usuario.persona.correo : null;
    if (!email) {
      NotificationManager.warning("El usuario no tiene correo registrado");
      return;
    }
    setCreandoId(usuario.id);
    const agente = { email: email, password: "SecurePass123$" };
    Crud_Catalogos(
      "softphone_v3/crear_agente?provedor=4&id=" +
        usuario.id +
        "&idPlataforma=" +
        plataformaSeleccionada.value,
      "softphone",
      "post",
      "",
      agente
    )
      .then((res) => {
        if (res && (res.status === 201 || res.status === 200)) {
          NotificationManager.success(res.message || "Usuario webphone creado correctamente");
        } else {
          NotificationManager.warning(
            (res && res.message) || "No se pudo crear el usuario webphone"
          );
        }
        // refrescar el listado global de extensiones para actualizar la tabla
        cargarExtensiones();
      })
      .catch(() => NotificationManager.error("Error al crear el usuario webphone"))
      .finally(() => setCreandoId(null));
  };

  // Normaliza la lista de extensiones que devuelve Lambicom.
  // El backend envuelve la respuesta en RespuestaGenerica: el JSON de Lambicom
  // puede venir como string en `data` o ya parseado. La estructura es
  // { extensions: [...], page, total, total_pages }.
  const normalizarExtensiones = (res) => {
    let payload = res;
    // RespuestaGenerica -> { status, message, data }
    if (payload && payload.data !== undefined) {
      payload = payload.data;
    }
    // data puede venir como string JSON
    if (typeof payload === "string") {
      try {
        payload = JSON.parse(payload);
      } catch (e) {
        return [];
      }
    }
    if (payload && Array.isArray(payload.extensions)) return payload.extensions;
    if (Array.isArray(payload)) return payload;
    return [];
  };

  // Etiqueta legible para una extensión disponible
  const etiquetaExtension = (ext) => {
    const sip = ext.sip_extension || ext.extension || ext.id;
    const nombre = ext.display_name || ext.user_name || ext.caller_id_name || "";
    return nombre ? `${sip} - ${nombre}` : `${sip}`;
  };

  // Abre el modal de asignación para un usuario y carga las extensiones disponibles
  const abrirAsignar = (usuario) => {
    if (!plataformaSeleccionada.value) {
      NotificationManager.warning("Selecciona una plataforma primero");
      return;
    }
    setUsuarioAsignar(usuario);
    setExtensionSeleccionada(null);
    setShowAsignar(true);
    cargarDisponibles();
  };

  // Carga las extensiones NO asignadas del PBX (Lambicom), filtradas por el
  // area_id de la configuración de la plataforma cuando exista.
  const cargarDisponibles = () => {
    setCargandoDisponibles(true);
    setExtensionesDisponibles([]);
    let url = "softphone_v3/extensiones?provedor=4&assigned=false&limit=100";
    if (plataformaConfig && plataformaConfig.areaId) {
      url += "&area_id=" + plataformaConfig.areaId;
    }
    Crud_Catalogos(url, "softphone", "get", "", [])
      .then((res) => {
        const lista = normalizarExtensiones(res);
        // Solo las que no tienen usuario asignado
        const disponibles = lista.filter((e) => !e.user_id);
        const opciones = disponibles.map((e) => ({
          value: e.id,
          label: etiquetaExtension(e),
          data: e,
        }));
        setExtensionesDisponibles(opciones);
      })
      .catch(() =>
        NotificationManager.error("Error al cargar extensiones disponibles")
      )
      .finally(() => setCargandoDisponibles(false));
  };

  // Asigna la extensión seleccionada al usuario elegido.
  // POST /softphone_v3/extensiones/{extensionId}/asignar?provedor=4&id={idUsuario}
  const asignarExtension = () => {
    if (!extensionSeleccionada || !extensionSeleccionada.value) {
      NotificationManager.warning("Selecciona una extensión");
      return;
    }
    if (!usuarioAsignar) return;
    setAsignando(true);
    Crud_Catalogos(
      "softphone_v3/extensiones/" +
        extensionSeleccionada.value +
        "/asignar?provedor=4&id=" +
        usuarioAsignar.id,
      "softphone",
      "post",
      "",
      {}
    )
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          NotificationManager.success(res.message || "Extensión asignada correctamente");
          setShowAsignar(false);
          cargarExtensiones();
        } else {
          NotificationManager.warning(
            (res && res.message) || "No se pudo asignar la extensión"
          );
        }
      })
      .catch(() => NotificationManager.error("Error al asignar la extensión"))
      .finally(() => setAsignando(false));
  };

  // Desasigna la extensión de un usuario.
  // POST /softphone_v3/extensiones/{extensionId}/desasignar?provedor=4
  // El extensionId es el UUID de la extensión (Softphone.extensionUuid).
  const desasignarExtension = (usuario, ext) => {
    const extensionId = ext.extensionUuid || ext.idPbxUuid;
    if (!extensionId) {
      NotificationManager.warning(
        "La extensión no tiene un identificador (UUID) para desasignar"
      );
      return;
    }
    setDesasignandoId(usuario.id);
    Crud_Catalogos(
      "softphone_v3/extensiones/" + extensionId + "/desasignar?provedor=4",
      "softphone",
      "post",
      "",
      {}
    )
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          NotificationManager.success(res.message || "Extensión desasignada correctamente");
          cargarExtensiones();
        } else {
          NotificationManager.warning(
            (res && res.message) || "No se pudo desasignar la extensión"
          );
        }
      })
      .catch(() => NotificationManager.error("Error al desasignar la extensión"))
      .finally(() => setDesasignandoId(null));
  };

  // Helper para renderizar una fila "etiqueta: valor" en el modal de detalles
  const renderDetalle = (label, valor) => (
    <div className="mb-2">
      <strong>{label}:</strong>{" "}
      {valor !== null && valor !== undefined && valor !== "" ? (
        valor
      ) : (
        <span className="text-muted">-</span>
      )}
    </div>
  );

  // Abre el modal de configuración. Si ya existe config (tiene id), precarga
  // sus valores; si no, inicializa un registro nuevo con id === id_plataforma.
  const abrirConfig = () => {
    if (!plataformaSeleccionada.value) {
      NotificationManager.warning("Selecciona una plataforma primero");
      return;
    }
    const existe = plataformaConfig && plataformaConfig.id;
    if (existe) {
      setConfigForm({ ...plataformaConfig });
      setConfigEsNuevo(false);
      // Inicializar los objetos seleccionados con el UUID como label temporal;
      // al cargar las opciones se reemplaza por el name real.
      setTeamSeleccionado(
        plataformaConfig.teamId
          ? { value: plataformaConfig.teamId, label: plataformaConfig.teamId }
          : null
      );
      setAreaSeleccionada(
        plataformaConfig.areaId
          ? { value: plataformaConfig.areaId, label: plataformaConfig.areaId }
          : null
      );
    } else {
      // El id de la configuración de plataforma ES el id de la plataforma
      setConfigForm({
        id: plataformaSeleccionada.value,
        idGrupo: null,
        extension: "",
        teamId: "",
        areaId: "",
        caller_id: "",
        estatus: true,
        softphoneConfiguracionId: 4,
      });
      setConfigEsNuevo(true);
      setTeamSeleccionado(null);
      setAreaSeleccionada(null);
    }
    // Cargar opciones para los selects de área y team
    cargarTeamsOpciones();
    cargarBranchYAreas();
    setShowConfig(true);
  };

  // Actualiza un campo del formulario de configuración
  const onConfigChange = (campo, valor) => {
    setConfigForm((prev) => ({ ...prev, [campo]: valor }));
  };

  // Normaliza una respuesta que puede venir como array directo o envuelta
  // en { data: [...] }, { areas: [...] } o { teams: [...] }.
  const normalizarLista = (res, clave) => {
    if (Array.isArray(res)) return res;
    if (res && Array.isArray(res[clave])) return res[clave];
    if (res && Array.isArray(res.data)) return res.data;
    return [];
  };

  // Carga el catálogo de teams recorriendo TODAS las páginas (GET /pbx/teams).
  // La respuesta trae { data: [...], meta: { page, per_page, total, total_pages } }.
  // Se itera desde la página 1 hasta meta.total_pages.
  const cargarTeamsOpciones = () => {
    const LIMIT = 100;

    const traerPagina = (page, acumulado) => {
      return Crud_Catalogos(
        "softphone_v3/teams?provedor=4&page=" + page + "&limit=" + LIMIT,
        "softphone",
        "get",
        "",
        []
      ).then((res) => {
        const lista = normalizarLista(res, "teams");
        const nuevos = acumulado.concat(lista);
        const totalPages =
          res && res.meta && res.meta.total_pages ? res.meta.total_pages : 1;
        if (page < totalPages) {
          return traerPagina(page + 1, nuevos);
        }
        return nuevos;
      });
    };

    traerPagina(1, [])
      .then((todos) => {
        const opciones = todos.map((t) => ({
          value: t.id,
          label: t.name || t.id,
          data: t,
        }));
        setTeamOpciones(opciones);
        // Resolver el label real del team ya seleccionado (si está en la lista)
        setTeamSeleccionado((prev) => {
          if (!prev) return prev;
          const enLista = opciones.find((o) => o.value === prev.value);
          return enLista || prev;
        });
      })
      .catch(() => NotificationManager.error("Error al cargar teams"));
  };

  // Obtiene el branch_id de la config global (id=4) y luego lista sus áreas
  const cargarBranchYAreas = () => {
    Crud_Catalogos("softphone_server_configuracion/4", "", "get", "", [])
      .then((cfg) => {
        const branchId = cfg && cfg.branchId ? cfg.branchId : null;
        if (!branchId) {
          setAreaOpciones([]);
          NotificationManager.warning(
            "La configuración global no tiene branch_id definido"
          );
          return;
        }
        return Crud_Catalogos(
          "softphone_v3/areas?provedor=4&branchId=" + branchId,
          "softphone",
          "get",
          "",
          []
        ).then((res) => {
          const lista = normalizarLista(res, "areas");
          const opciones = lista.map((a) => ({
            value: a.id,
            label: a.name || a.id,
            data: a,
          }));
          setAreaOpciones(opciones);
          // Resolver el label real del área ya seleccionada (si está en la lista)
          setAreaSeleccionada((prev) => {
            if (!prev) return prev;
            const enLista = opciones.find((o) => o.value === prev.value);
            return enLista || prev;
          });
        });
      })
      .catch(() => NotificationManager.error("Error al cargar áreas"));
  };

  // Guarda la configuración (crea o actualiza según configEsNuevo)
  const guardarConfig = () => {
    // Aseguramos que el id sea el de la plataforma seleccionada y la config global = 4
    const payload = {
      ...configForm,
      id: plataformaSeleccionada.value,
      softphoneConfiguracionId: configForm.softphoneConfiguracionId || 4,
    };
    setGuardandoConfig(true);
    const metodo = configEsNuevo ? "post" : "put";
    Crud_Catalogos("softphone_configuracion", "", metodo, "", payload)
      .then(() => {
        NotificationManager.success(
          configEsNuevo ? "Configuración creada" : "Configuración actualizada"
        );
        setShowConfig(false);
        // Refrescar la config y sus datos derivados (área/team)
        cargarPlataformaConfig(plataformaSeleccionada.value);
      })
      .catch(() => NotificationManager.error("Error al guardar la configuración"))
      .finally(() => setGuardandoConfig(false));
  };

  return (
    <SiteWrapper>
      <div className="container mt-3">
        <Grid.Row>
          <Grid.Col sm={12} lg={12}>
            <Card>
              <Card.Header>
                <Card.Title>Administración de Extensiones</Card.Title>
              </Card.Header>
              <Card.Body>
                <Grid.Row className="align-items-center mb-4">
                  <Grid.Col sm={12} md={4}>
                    <label className="form-label">Plataforma</label>
                    <Select
                      value={plataformaSeleccionada}
                      onChange={(e) => {
                        setPlataformaSeleccionada(e);
                      }}
                      options={plataformas}
                    />
                  </Grid.Col>
                  <Grid.Col sm={12} md={8}>
                    {plataformaSeleccionada.value ? (
                      plataformaConfig ? (
                        <div className="mt-4 mt-md-0">
                          <div>
                            <strong>Extensión:</strong>{" "}
                            {plataformaConfig.extension || "-"}
                          </div>
                          <div>
                            <strong>Caller ID:</strong>{" "}
                            {plataformaConfig.caller_id || "-"}
                          </div>
                          <div>
                            <strong>Área:</strong>{" "}
                            {areaInfo && areaInfo.name ? (
                              areaInfo.name
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </div>
                          <div>
                            <strong>Team:</strong>{" "}
                            {teamInfo && teamInfo.name ? (
                              teamInfo.name
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </div>
                          <div>
                            <strong>Estatus:</strong>{" "}
                            {plataformaConfig.estatus ? (
                              <Badge color="success">Activo</Badge>
                            ) : (
                              <Badge color="secondary">Inactivo</Badge>
                            )}
                          </div>
                          <button
                            type="button"
                            className="btn btn-outline-primary btn-sm mt-2"
                            title="Ver detalles de la plataforma, área y team"
                            onClick={() => setShowDetalle(true)}
                          >
                            <i className="fa fa-eye mr-1" /> Ver detalles
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm mt-2 ml-2"
                            title="Configurar plataforma"
                            onClick={abrirConfig}
                          >
                            <i className="fa fa-cog" />
                          </button>
                        </div>
                      ) : (
                        <div className="mt-4 mt-md-0">
                          <div className="text-muted mb-2">
                            Sin configuración para esta plataforma
                          </div>
                          <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm"
                            title="Configurar plataforma"
                            onClick={abrirConfig}
                          >
                            <i className="fa fa-cog mr-1" /> Configurar
                          </button>
                        </div>
                      )
                    ) : null}
                  </Grid.Col>
                </Grid.Row>
                {loading ? (
                  <div>Cargando...</div>
                ) : (
                  <TablePageable
                    lista={usuarios}
                    columnas={[
                      { columna: "id", label: "ID" },
                      { columna: "username", label: "Usuario" },
                      {
                        columna: "nombreCompleto",
                        label: "Nombre",
                        form: (u) =>
                          `${u.persona ? u.persona.nombre || "" : ""} ${
                            u.persona ? u.persona.aPaterno || "" : ""
                          }`.trim(),
                      },
                      {
                        columna: "email",
                        label: "Email",
                        form: (u) =>
                          u.persona && u.persona.correo ? (
                            u.persona.correo
                          ) : (
                            <span className="text-muted">-</span>
                          ),
                      },
                      {
                        columna: "webphoneUser",
                        label: "Webphone User",
                        form: (u) => {
                          const exts = extensionesUsuario(u.id);
                          if (exts.length === 0) {
                            return (
                              <Button
                                size="sm"
                                color="primary"
                                title="Es el usuario de telefonía, este será necesario para asociar una extensión"
                                disabled={
                                  creandoId === u.id || !plataformaSeleccionada.value
                                }
                                onClick={() => crearUsuarioWebphone(u)}
                              >
                                {creandoId === u.id ? "Creando..." : "Crear"}
                              </Button>
                            );
                          }
                          return (
                            <ul className="mb-0 pl-3">
                              {exts.map((e, i) => (
                                <li key={i}>
                                  {nombrePlataforma(e.idPlataforma)}:{" "}{e.sipExtension}({e.extension})
                                </li>
                              ))}
                            </ul>
                          );
                        },
                      },
                      {
                        columna: "tieneExtension",
                        label: "Extensión",
                        form: (u) => {
                          const exts = extensionesUsuario(u.id);
                          // El usuario/agente webphone debe existir antes de asignar extensión
                          const tieneUsuarioWebphone = exts.length > 0;
                          // Se considera que TIENE extensión si alguna de sus
                          // entradas trae extension_uuid (extensionUuid).
                          const extConUuid = exts.find(
                            (e) => e.extensionUuid && e.extensionUuid !== ""
                          );
                          if (!extConUuid) {
                            return (
                              <Button
                                size="sm"
                                color="primary"
                                title={
                                  tieneUsuarioWebphone
                                    ? "Asignar una extensión disponible a este usuario"
                                    : "Primero crea el usuario webphone"
                                }
                                disabled={
                                  !plataformaSeleccionada.value ||
                                  !tieneUsuarioWebphone
                                }
                                onClick={() => abrirAsignar(u)}
                              >
                                Asignar
                              </Button>
                            );
                          }
                          return (
                            <Button
                              size="sm"
                              color="danger"
                              title="Desasignar la extensión de este usuario"
                              disabled={desasignandoId === u.id}
                              onClick={() => desasignarExtension(u, extConUuid)}
                            >
                              {desasignandoId === u.id
                                ? "Desasignando..."
                                : "Desasignar"}
                            </Button>
                          );
                        },
                      },
                    ]}
                    id="id"
                    selected={() => {}}
                    csvname={plataformaSeleccionada.label + "-Usuarios"}
                    paginacion={true}
                    elementosPorPagina={30}
                  />
                )}
              </Card.Body>
            </Card>
          </Grid.Col>
        </Grid.Row>

        {/* Modal de detalles de la plataforma / área / team */}
        {showDetalle ? (
          <div
            className="modal fade show"
            style={{
              display: "block",
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 1050,
            }}
            onClick={(e) => {
              if (e.target === e.currentTarget) setShowDetalle(false);
            }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    Detalles de {plataformaSeleccionada.label}
                  </h5>
                  <button
                    type="button"
                    className="close"
                    onClick={() => setShowDetalle(false)}
                  >
                  </button>
                </div>
                <div className="modal-body">
                  <Grid.Row>
                    <Grid.Col sm={12} md={4}>
                      <h4 className="mb-3">Configuración</h4>
                      {renderDetalle("Extensión", plataformaConfig?.extension)}
                      {renderDetalle("Caller ID", plataformaConfig?.caller_id)}
                      {renderDetalle("ID Grupo", plataformaConfig?.idGrupo)}
                      {renderDetalle("Team ID", plataformaConfig?.teamId)}
                      {renderDetalle("Area ID", plataformaConfig?.areaId)}
                      {renderDetalle(
                        "Estatus",
                        plataformaConfig?.estatus ? "Activo" : "Inactivo"
                      )}
                    </Grid.Col>
                    <Grid.Col sm={12} md={4}>
                      <h4 className="mb-3">Área</h4>
                      {areaInfo ? (
                        <>
                          {renderDetalle("Nombre", areaInfo.name)}
                          {renderDetalle("ID", areaInfo.id)}
                          {renderDetalle("Código", areaInfo.code)}
                          {renderDetalle("Descripción", areaInfo.description)}
                          {renderDetalle(
                            "Activa",
                            areaInfo.is_active ? "Sí" : "No"
                          )}
                        </>
                      ) : (
                        <div className="text-muted">Sin información de área</div>
                      )}
                    </Grid.Col>
                    <Grid.Col sm={12} md={4}>
                      <h4 className="mb-3">Team</h4>
                      {teamInfo ? (
                        <>
                          {renderDetalle("Nombre", teamInfo.name)}
                          {renderDetalle("ID", teamInfo.id)}
                          {renderDetalle("Código", teamInfo.code)}
                          {renderDetalle("Descripción", teamInfo.description)}
                          {renderDetalle(
                            "Activo",
                            teamInfo.is_active ? "Sí" : "No"
                          )}
                        </>
                      ) : (
                        <div className="text-muted">Sin información de team</div>
                      )}
                    </Grid.Col>
                  </Grid.Row>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowDetalle(false)}
                  >
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {/* Modal de configuración de plataforma (crear / actualizar) */}
        {showConfig ? (
          <div
            className="modal fade show"
            style={{
              display: "block",
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 1050,
            }}
            onClick={(e) => {
              if (e.target === e.currentTarget) setShowConfig(false);
            }}
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {configEsNuevo ? "Crear" : "Editar"} configuración -{" "}
                    {plataformaSeleccionada.label}
                  </h5>
                  <button
                    type="button"
                    className="close"
                    onClick={() => setShowConfig(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="form-group">
                    <label className="form-label">ID Plataforma</label>
                    <input
                      type="text"
                      className="form-control"
                      value={configForm.id || plataformaSeleccionada.value}
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Extensión</label>
                    <input
                      type="text"
                      className="form-control"
                      value={configForm.extension || ""}
                      onChange={(e) => onConfigChange("extension", e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Caller ID</label>
                    <input
                      type="text"
                      className="form-control"
                      value={configForm.caller_id || ""}
                      onChange={(e) => onConfigChange("caller_id", e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">ID Grupo</label>
                    <input
                      type="number"
                      className="form-control"
                      value={
                        configForm.idGrupo !== null &&
                        configForm.idGrupo !== undefined
                          ? configForm.idGrupo
                          : ""
                      }
                      onChange={(e) =>
                        onConfigChange(
                          "idGrupo",
                          e.target.value === "" ? null : parseInt(e.target.value, 10)
                        )
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Team</label>
                    <Select
                      value={teamSeleccionado}
                      onChange={(op) => {
                        setTeamSeleccionado(op || null);
                        onConfigChange("teamId", op ? op.value : "");
                      }}
                      options={teamOpciones}
                      isClearable
                      placeholder="Selecciona un team"
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Área</label>
                    <Select
                      value={areaSeleccionada}
                      onChange={(op) => {
                        setAreaSeleccionada(op || null);
                        onConfigChange("areaId", op ? op.value : "");
                      }}
                      options={areaOpciones}
                      isClearable
                      placeholder="Selecciona un área"
                    />
                  </div>
                  <div className="form-group">
                    <label className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        checked={!!configForm.estatus}
                        onChange={(e) =>
                          onConfigChange("estatus", e.target.checked)
                        }
                      />
                      <span className="custom-control-label">Activo</span>
                    </label>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowConfig(false)}
                    disabled={guardandoConfig}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={guardarConfig}
                    disabled={guardandoConfig}
                  >
                    {guardandoConfig ? "Guardando..." : "Guardar"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {/* Modal de asignación de extensión */}
        {showAsignar ? (
          <div
            className="modal fade show"
            style={{
              display: "block",
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 1050,
            }}
            onClick={(e) => {
              if (e.target === e.currentTarget) setShowAsignar(false);
            }}
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    Asignar extensión
                    {usuarioAsignar
                      ? " - " +
                        (usuarioAsignar.persona
                          ? `${usuarioAsignar.persona.nombre || ""} ${
                              usuarioAsignar.persona.aPaterno || ""
                            }`.trim()
                          : usuarioAsignar.username)
                      : ""}
                  </h5>
                  <button
                    type="button"
                    className="close"
                    onClick={() => setShowAsignar(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="form-group">
                    <label className="form-label">
                      Extensiones disponibles
                    </label>
                    <Select
                      value={extensionSeleccionada}
                      onChange={(op) => setExtensionSeleccionada(op || null)}
                      options={extensionesDisponibles}
                      isClearable
                      isLoading={cargandoDisponibles}
                      placeholder={
                        cargandoDisponibles
                          ? "Cargando extensiones..."
                          : "Selecciona una extensión"
                      }
                      noOptionsMessage={() => "No hay extensiones disponibles"}
                    />
                    {!cargandoDisponibles &&
                    extensionesDisponibles.length === 0 ? (
                      <small className="text-muted">
                        No se encontraron extensiones disponibles
                        {plataformaConfig && plataformaConfig.areaId
                          ? " para el área configurada"
                          : ""}
                        .
                      </small>
                    ) : null}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowAsignar(false)}
                    disabled={asignando}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={asignarExtension}
                    disabled={asignando || !extensionSeleccionada}
                  >
                    {asignando ? "Asignando..." : "Asignar"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </SiteWrapper>
  );
};

export default AdminExtensionesPage;
